$(function () {
    let height = $('.fixme').height();
    let viewPortHeight = window.innerHeight - 100;
    if($('#products-filter').length > 0 && height < viewPortHeight) {
        trackScrollMenu();
    }
});

function trackScrollMenu() {
    $(window).scroll(function () {
        let elementTop = $('#products-filter').offset().top;
        let scrollTop = $(window).scrollTop();
       if((scrollTop - elementTop) > -130 ) {
           document.body.classList.add('fixed-filter');
       }
       else {
           document.body.classList.remove('fixed-filter');

       }

    });
}